import { useCallback } from 'react';
import { trpc } from '@client/trpc';

export function useLogout() {
  const utils = trpc.useUtils();

  return useCallback(() => {
    localStorage.removeItem('accessToken');
    utils.auth.getCurrentUser.invalidate();
  }, [utils]);
}
